import React from 'react'
import { useNavigate } from 'react-router-dom'
import logo from "../Images/logo.png"

function Navbar() {
  const navigate = useNavigate()
  return (
    <nav className='w-[85%] scroll-smooth h-[3.75rem] flex items-center flex-row py-3 px-5 bg-[#7B4AE2]/5 rounded-2xl mt-10'>
        <img onClick={() => navigate("#")} src={logo} alt="Yusuf Yıldız" className='h-full cursor-pointer mr-auto'/>
        <ul className='flex phone:gap-3 md:gap-7 phone:text-sm sm:text-[18px] text-white/50'>
            <li><a className='hover:text-[#7B4AE2]/50 transition-all duration-100 font-light' href="#home">Home</a></li>
            <li><a className='hover:text-[#7B4AE2]/50 transition-all duration-100 font-light' href="#about">About</a></li>
            <li><a className='hover:text-[#7B4AE2]/50 transition-all duration-100 font-light' href="#skills">Skills</a></li>
        </ul>
    </nav>
  )
}

export default Navbar